<template>
  <div>
    <span :class="['firstTitle',{ secondTitle: isActiveSec },{'width-700':isWidth700},{'width-840':isWidth840}]"><i></i>{{title}}</span>
  </div>
</template>

<script>

export default {
  data () {
    return {
      options: {},
    };
  },
  components: {

  },
  props: {
    title: {
      type: String,
      default: () => ({})
    },
    isActiveSec:{
      type: Boolean,
      default: false
    },
    isWidth700:{
      type: Boolean,
      default: false
    },
    isWidth840:{
      type: Boolean,
      default: false
    }
  },
  watch: {
    
  },
}
</script>
<style lang="scss">
.firstTitle{
  width:511px;
  height:35px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  // height:34px;
  line-height: 34px;
  display: flex;
  // align-items: center;
  background: url("~@/assets/images/index/title.png") no-repeat;
  background-size: cover;
  padding-left:30px;
}
.secondTitle{
  width: 500px;
  height:35px;
  font-size: 22px;
  align-items: center;
  background: url("~@/assets/images/index/title_small.png") no-repeat;
  background-size: 500px 35px;
  padding-left:20px;
  i{
    width: 7px;
    height: 7px;
    background: #FFFFFF;
    display: inline-block;
    border-radius: 100%;
    margin-right:5px;
  }
}
.width-700{
  width:700px;
  background-size: 700px 34px;
  padding-left:50px;
}
.width-840{
  width:840px;
  background-size: 840px 34px;
  padding-left:50px;
}
</style>